function ThirdPillarSelect() {
  const errorMessagesTemplate = Handlebars.compile($('#error-messages-partial').html())
  const luminorAvailableFunds = getArrayOfMapValues(LuminorThirdPillarFunds)
  const allAvailableFunds = AllThirdPillarFunds
  const renderer = require('Renderer')

  let params
  let defaultFrom
  let thirdPillar
  let thirdPillarNewFundsSelection
  let distributionRows

  this.init = function (urlParams) {
    thirdPillar = session.pension.thirdPillar

    if (urlParams.selectedStrategy) {
      const strategy = new Strategy(urlParams.selectedStrategy, Funds.thirdPillar)

      distributionRows = new Distributor().distributionByStrategy(strategy, thirdPillar.assets);
      thirdPillarNewFundsSelection = new ThirdPillarNewFundsSelection(strategy, allAvailableFunds, Labels)
    }
    else {
      distributionRows = initialDistribution();
      thirdPillarNewFundsSelection = new ThirdPillarNewFundsSelection(thirdPillar.activeFunds, allAvailableFunds, Labels)
    }

    defaultFrom = distributionRows.length ? distributionRows[0].from : undefined;
    params = {
      shouldShowFinalEncouragement: !!urlParams.selectedStrategy,
      hasAssets: thirdPillar.assets.length > 0,
      activeFunds: thirdPillar.activeFunds,
      activeFundIsin: thirdPillar.activeFunds[0] ? thirdPillar.activeFunds[0].fund.isin : "",
      funds: luminorAvailableFunds,
      pension: thirdPillar,
      distributionRows: distributionRows,
      showSelectFundOption: true
    }
    return params
  }

  function getArrayOfMapValues(funds) {
    return Object.keys(funds).map(isin => {return funds[isin]})
  }

  this.done = function (urlParams) {
    drawDistributionRows()
    thirdPillarNewFundsSelection.init()
    addHandlers(urlParams)
  }

  function addHandlers(urlParams) {
    $('#distribution').change(updateDistributionRow)
      .on('click', '.delete', deleteDistributionRow)
    $('#add-distribution-row').click(addDistributionRow)
    $('#delete-all').click(deleteAllDistributionRows)
    $('#application-form').submit((e) => submit(e, urlParams))
  }

  function submit(e) {
    e.preventDefault()

    return $.post('/application/third-pillar/validate', {
      distributionRows: JSON.stringify(distributionRows),
      newFunds: JSON.stringify(thirdPillarNewFundsSelection.getActiveFundsList())
    })
      .done(function() {
        sessionStorage.setItem('thirdPillarApplication', JSON.stringify({
          distributionRows: distributionRows,
          newFunds: thirdPillarNewFundsSelection.getActiveFundsList()
        }))

        location.href = '#third-pillar-application'
      })
      .fail(function (xhr) {
        Logger.error('Application error: ' + xhr.responseText);
        drawErrorMessages(xhr.responseJSON.validationErrors)
      })
  }

  function drawDistributionRows() {
    $('#distribution').html(renderer.template('distribution-partial-third')({
      distributionRows: distributionRows.map(function(row) {
        return {
          assets: params.pension.assets,
          funds: params.funds,
          from: row.from,
          to: row.to,
          percentage: row.percentage,
          percentageError: !isValidPercentage(row.percentage),
          units: row.units,
          showSelectFundOption: row.showSelectFundOption
        }
      })
    }))

  }

  function initialDistribution() {
    return thirdPillar.assets.reduce(function (memo, a) {
      memo.push(
        {
          from: a.fund.isin,
          percentage: 100,
          to: '',
          units: a.unitAmount
        })
      return memo
    }, [])
  }

  function drawErrorMessages(errorMessages) {
    const message = $('#error-messages').empty()
    message.append(errorMessagesTemplate({errorMessages: buildMessages(errorMessages)}))
  }

  function buildMessages(errorMessages) {
    const thirdPillarFunds = thirdPillar.assets
      .map(asset => asset.fund)
      .reduce((memo, fund) => {
        memo[fund.isin] = fund;
        return memo;
      }, {});

    return errorMessages.reduce(function (memo, e) {
      memo.push({
        name: (LuminorThirdPillarFunds[e.isin] || thirdPillarFunds[e.isin] || {}).name,
        message: e.message,
        error_label: Labels['secondPillar-application-' + e.message.toLowerCase()]
      })
      return memo
    }, [])
  }

  function updateDistributionRow(event) {
    const target = $(event.target)
    const fundSellPercentage = target.val()
    const rowIndex = target.closest('.row').data('rowIndex')
    const rowIsin = target.data('isin')

    if (rowIsin) {
      const unitAmount = params.pension.assets.find(v => v.fund.isin === rowIsin).unitAmount
      distributionRows[rowIndex]['units'] = unitAmount * fundSellPercentage / 100.0
    }
    distributionRows[rowIndex][target[0].name] = fundSellPercentage

    drawDistributionRows()
  }

  function deleteDistributionRow(event) {
    let rowIndex = $(event.target).closest('.row').data('rowIndex')
    distributionRows.splice(rowIndex, 1)
    drawDistributionRows()
  }

  function deleteAllDistributionRows() {
    distributionRows = []
    drawDistributionRows()
  }

  function addDistributionRow() {
    distributionRows.push({from: defaultFrom, percentage: 100, to: '', units: 0})
    drawDistributionRows()
  }

  function isValidPercentage(value) {
    return !isNaN(value) && value >= 0 && value <= 100
  }
}
